import React from "react";
import NoDataFound from "Common/NoDataFound";
import { FeatureSafe } from "./FeatureSafe";

const DefaultSectionFallback = ({ label }) => (
  <section className="py-4">
    <NoDataFound
      className="min-h-24"
      heading={label ? `${label} could not be loaded` : "No Data"}
    />
  </section>
);

/**
 * Isolates a page subsection (tabs, widgets, nested panels).
 * On error, shows empty UI instead of breaking the route.
 */
export const SectionSafe = ({
  children,
  componentName,
  fallback,
  label,
  silent = true,
}) => (
  <FeatureSafe
    componentName={componentName || label}
    silent={silent}
    fallback={fallback ?? <DefaultSectionFallback label={label} />}
  >
    {children}
  </FeatureSafe>
);
